import { useEffect } from 'react';
import type { ModalProps } from '~/modal/modalType.enum';
import type { DataLayerGroupId } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.state';
import { useDataLayersEditViaBTG } from '../useDataLayersEditViaBTG';
import { DataLayerStyleEditModalComponent } from './dataLayerStyleEditModal.component';

export type DataLayerStyleEditModalProps = ModalProps<{
  dataLayerGroupId: DataLayerGroupId;
}>;

export const DataLayerStyleEditModalContainer = ({
  dataLayerGroupId,
  ...modalProps
}: DataLayerStyleEditModalProps) => {
  const {
    dataLayerGroup,
    boundaryTerritoryGroup,
    boundaryGroup,
    updateBoundaryTerritoryGroup,
    onSubmit,
  } = useDataLayersEditViaBTG(dataLayerGroupId);

  const onSubmitClick = () => {
    onSubmit({ onDone: () => modalProps.onClose() });
  };

  useEffect(() => {
    if (!dataLayerGroup) {
      modalProps.onClose();
    }
  }, [dataLayerGroup, modalProps]);

  if (!dataLayerGroup || !boundaryTerritoryGroup || !boundaryGroup) {
    return null;
  }

  return (
    <DataLayerStyleEditModalComponent
      boundaryTerritoryGroup={boundaryTerritoryGroup}
      boundaryGroup={boundaryGroup}
      onBoundaryTerritoryGroupChange={updateBoundaryTerritoryGroup}
      onSubmitClick={onSubmitClick}
      {...modalProps}
    />
  );
};
